export const EbillTitle = 'Do you still require paper bills?';
export const EbillMessage = `
  By switching to paperless billing you’ll be helping towards building a more
  sustainable future. By accpting eBills only we will update your preference
  and stop paper bills being generated for all products under each site
  linked to your account.
`;
